import {
  FETCH_EXISTING_SUBDIMENSIONS_REQUEST,
  FETCH_EXISTING_SUBDIMENSIONS_SUCCESS,
  FETCH_EXISTING_SUBDIMENSIONS_FAILURE,
} from "../actions/fetchExistingSubdimensionsActions";

const initialState = {
  loadingDimensions: false,
  data: [],
  error: null,
};

const fetchExistingSubdimensionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXISTING_SUBDIMENSIONS_REQUEST:
      return {
        ...state,
        loadingDimensions: true,
        error: null,
      };

    case FETCH_EXISTING_SUBDIMENSIONS_SUCCESS:
      return {
        ...state,
        loadingDimensions: false,
        data: action.payload,
      };

    case FETCH_EXISTING_SUBDIMENSIONS_FAILURE:
      return {
        ...state,
        loadingDimensions: false,
        error: action.payload,
        data: [],
      };

    default:
      return state;
  }
};

export default fetchExistingSubdimensionsReducer;
